import { queryOptions } from "@tanstack/react-query";
import { POLL_MS, apiGet, withQuery } from "@amber/ui";
import { deletedResponseSchema } from "@amber/application/contracts";
import { collectionKeys } from "@amber/collection/ui";

export const deletedQuery = (tab: "deleted" | "restricted") =>
  queryOptions({
    queryKey: collectionKeys.deleted(tab),
    queryFn: ({ signal }) => apiGet(withQuery("/api/collection/deleted", { tab }), deletedResponseSchema, signal),
    refetchInterval: POLL_MS,
  });
